import Actions from '../../odata/actions';

const actions = new Actions('completedTaskComment', 'completedTaskComments');

export default actions;
